import { Flex } from 'antd';
import _ from 'lodash';
import { useEffect } from "react";
type ActionTemplateProps = {
    spoId?: string;
    htmlContent?: string;
}

export const ActionTemplate = (props: ActionTemplateProps) => {
    useEffect(() => {
    }, [props.htmlContent])


    return (
        <div>
            {
                props.htmlContent
                &&
                <Flex vertical>
                    <div dangerouslySetInnerHTML={{ __html: props.htmlContent }} />
                </Flex>
            }
        </div>
    )
}